import React from "react";
import { Modal, Spinner, ProgressBar } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

export default function ExportLoadingModal({
  show,
  titleId = "indicator.exportar.todos.modal.title",
  titleDefault = "A gerar ZIP de indicadores...",
  subtitleId = "indicator.exportar.todos.modal.preparing",
  subtitleDefault = "A preparar ficheiros...",
  subtitleValues,
  percent,
  blocking = true,
  size = "sm",
}) {
  const hasPct = typeof percent === "number" && !Number.isNaN(percent);
  const pct = hasPct ? Math.min(100, Math.max(0, Math.round(percent))) : 0;

  return (
    <Modal
      show={show}
      backdrop={blocking ? "static" : true}
      keyboard={!blocking}
      centered
      size={size}
    >
      <Modal.Body className="py-4">
        <div className="d-flex align-items-center">
          <Spinner animation="border" role="status" className="me-3" />
          <div>
            <div className="fw-semibold">
              <FormattedMessage id={titleId} defaultMessage={titleDefault} />
            </div>
            {subtitleId && (
              <div className="text-muted">
                <FormattedMessage
                  id={subtitleId}
                  defaultMessage={subtitleDefault}
                  values={subtitleValues}
                />
              </div>
            )}
          </div>
        </div>

        {hasPct && (
          <div className="mt-3">
            <ProgressBar now={pct} />
            <div className="text-end text-muted mt-1">{pct}%</div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
